import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {HostService} from '@app/core/global/host.service';

@Component({
    selector   : 'ngc-nav-item',
    templateUrl: './nav-item.component.html',
    styleUrls  : ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit {
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;

    constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
                private hostService: HostService) {
        iconRegistry.addSvgIcon('districts', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-d.svg'));
        iconRegistry.addSvgIcon('schools', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-s.svg'));
        iconRegistry.addSvgIcon('staff', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-sf.svg'));
        iconRegistry.addSvgIcon('students', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-st.svg'));
        iconRegistry.addSvgIcon('contacts', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-c.svg'));
        iconRegistry.addSvgIcon('groups', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-g.svg'));
        iconRegistry.addSvgIcon('sections', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-se.svg'));
        iconRegistry.addSvgIcon('courses', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-cr.svg'));
        iconRegistry.addSvgIcon('calendars', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-ca.svg'));
        iconRegistry.addSvgIcon('school-adm', sanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/icon-sa.svg'));

        /* .addSvgIconSetInNamespace('core',
                sanitizer.bypassSecurityTrustResourceUrl('/icon/assets/core-icon-set.svg'))
            .registerFontClassAlias('fontawesome', 'fa');*/
    }

    ngOnInit() {
    }

    openPassport() {
        const newWindow = window.open('', 'passport', '');
        if (newWindow != null) {
            this.hostService.getUrlOfPassport().subscribe(
                redirectData => {
                    if (redirectData != null) {
                        newWindow.location.href = redirectData.redirectUrl;
                    }
                },
                message => {
                });
        }
    }
}
